import { useI18n } from "@/i18n/I18nContext";
import { TextPageLayout } from "@/pages/components/TextPageLayout";
import { DocumentHead } from "@/seo/DocumentHead";

export function SupportPage() {
  const { messages } = useI18n();
  const s = messages.support;

  return (
    <TextPageLayout title={s.pageTitle}>
      <DocumentHead
        title={s.seoTitle}
        description={s.seoDescription}
        path="/support"
      />
      <h2 className="mb-4 text-3xl text-[#111111]">{s.getHelp.title}</h2>
      <p className="mb-6 text-gray-700">{s.getHelp.body}</p>

      <h2 className="mb-4 text-3xl text-[#111111]">{s.faq.title}</h2>
      <p className="mb-6 text-gray-700">{s.faq.body}</p>

      <h2 className="mb-4 text-3xl text-[#111111]">{s.contact.title}</h2>
      <p className="mb-4 text-gray-700">{s.contact.body}</p>
      <div className="mb-6 rounded-2xl border border-gray-200 bg-white p-6">
        <p className="mb-2 text-lg">
          <strong>{s.contact.emailLabel}</strong>{" "}
          <a
            href="mailto:support@wasok.app"
            className="text-[#4CAF50] hover:underline"
          >
            support@wasok.app
          </a>
        </p>
        <p className="text-sm text-gray-600">{s.contact.responseTime}</p>
      </div>

      <h2 className="mb-4 text-3xl text-[#111111]">{s.bugs.title}</h2>
      <p className="mb-4 text-gray-700">{s.bugs.body}</p>
      <ul className="mb-6 list-disc space-y-2 pl-6 text-gray-700">
        {s.bugs.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p className="mb-6 text-gray-700">
        {s.bugs.sendPrefix}{" "}
        <a
          href="mailto:bugs@wasok.app"
          className="text-[#4CAF50] hover:underline"
        >
          bugs@wasok.app
        </a>
      </p>

      <h2 className="mb-4 text-3xl text-[#111111]">{s.featureRequests.title}</h2>
      <p className="mb-6 text-gray-700">
        {s.featureRequests.bodyBefore}{" "}
        <a
          href="mailto:feedback@wasok.app"
          className="text-[#4CAF50] hover:underline"
        >
          feedback@wasok.app
        </a>
        {s.featureRequests.bodyAfter}
      </p>

      <h2 className="mb-4 text-3xl text-[#111111]">{s.knownIssues.title}</h2>
      <p className="mb-4 text-gray-700">{s.knownIssues.body}</p>
      <ul className="mb-6 list-disc space-y-2 pl-6 text-gray-700">
        {s.knownIssues.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <h2 className="mb-4 text-3xl text-[#111111]">{s.appUpdates.title}</h2>
      <p className="mb-6 text-gray-700">{s.appUpdates.body}</p>

      <h2 className="mb-4 text-3xl text-[#111111]">{s.community.title}</h2>
      <p className="mb-6 text-gray-700">{s.community.body}</p>

      <h2 className="mb-4 text-3xl text-[#111111]">{s.emergency.title}</h2>
      <p className="mb-6 text-gray-700">{s.emergency.body}</p>

      <div className="mt-12 rounded-3xl bg-gradient-to-br from-[#4CAF50] to-[#45a049] p-8 text-white">
        <h3 className="mb-3 text-2xl">{s.cta.heading}</h3>
        <p className="mb-6">{s.cta.body}</p>
        <a
          href="mailto:support@wasok.app"
          className="inline-block rounded-xl bg-white px-8 py-3 text-[#4CAF50] transition-colors duration-200 hover:bg-gray-100"
        >
          {s.cta.button}
        </a>
      </div>
    </TextPageLayout>
  );
}
